import { render, staticRenderFns } from "./ScrollTrap.vue?vue&type=template&id=f09a00bc&"
import script from "./ScrollTrap.vue?vue&type=script&lang=ts&"
export * from "./ScrollTrap.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports